import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PrimengModule } from 'src/app/primeng/primeng.module';
import { MxOverlayPanelComponent } from './mx.overlay-panel.component';

export const COMPONENTS: any[] = [MxOverlayPanelComponent];

@NgModule({
  imports: [CommonModule, PrimengModule],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class MxOverlayPanelModule {}
